// plugins/scroll.ts
export default defineNuxtPlugin((nuxtApp) => {
  const scrollPositions = new Map<string, { x: number; y: number }>()

  // nuxtApp.hook('page:finish', () => {
  //   const router = useRouter();
  //   scrollPositions.set(router.currentRoute.value.fullPath, { x: window.scrollX, y: window.scrollY });
  // });
  //
  // nuxtApp.hook('page:start', () => {
  //   const router = useRouter();
  //   const position = scrollPositions.get(router.currentRoute.value.fullPath);
  //   if (position) {
  //     window.scrollTo(position.x, position.y);
  //   }
  // });

  const router = useRouter()
  if (!router) return;

  router.beforeEach((to, from, next) => {
    if (from.name) {
      scrollPositions.set(from.fullPath, { x: window.scrollX, y: window.scrollY })
      console.log('scrollPositions:', scrollPositions)
    }
    next()
  })

  router.afterEach((to) => {
    const position = scrollPositions.get(router.currentRoute.value.fullPath)
    console.log(router.currentRoute.value.fullPath, position)
    if (position) {
      setTimeout(() => {
        window.scrollTo(position.x, position.y)
      }, 60)
    }
  })
})
